import axios from 'axios';
import {getLoginHeaders, urls} from './urls';
import {apiUrl} from './servers';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthApi {

  async loginUser(userLoginModel: any): Promise<any> {
    const endpoint = apiUrl + urls.auth;
    const body = userLoginModel.toString();
    const loginHeaders = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic ' + btoa('web:web-secret')
    };
    const response = await axios.post(endpoint, body, {headers: loginHeaders});
    return response;
  }

}

export const authApi = new AuthApi();
